











































import BaseFormMixin from '@/mixins/base-form-mixin';
import { DatasourceDto } from '@/services/datasource';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Watch } from 'vue-property-decorator';

@Component
export default class HiveConfForm extends mixins(BaseFormMixin) {
  @PropSync('formData') syncFormData!: DatasourceDto;

  hadoopConfStr: string = `{
    "hadoop.user.name": "root",
    "fs.defaultFS": "hdfs://ns",
    "dfs.nameservices": "ns",
    "dfs.ha.namenodes.ns": "nn1,nn2",
    "dfs.namenode.rpc-address.ns.nn1": "ip:9000",
    "dfs.namenode.rpc-address.ns.nn2": "ip:9000",
    "dfs.client.failover.proxy.provider.ns": "org.apache.hadoop.hdfs.server.namenode.ha.ConfiguredFailoverProxyProvider"
    "fs.hdfs.impl.disable.cache": "true",
    "fs.hdfs.impl": "org.apache.hadoop.hdfs.DistributedFileSystem"
  }`

  mounted() {
    this.syncFormData.hiveConf = {
      defaultFS: '',
      jdbcUrl: '',
      schema: '',
      username: '',
      password: '',
      //串属性
      hadoopInput: '',
      hadoopConfig: {}
    };
  }
}
